import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Button } from "react-bootstrap";

const RatingStar = ({ onRatingChange, initialRating }) => {
  const [rating, setRating] = useState(initialRating);
  const [hovered, setHovered] = useState(null);

  const handleClick = (rate) => {
    if (process.env.NODE_ENV === "development") {
      console.log("Selected rating:", rate);
    }
    setRating(rate);
    if (onRatingChange) {
      onRatingChange(rate); // pass rating to parent if needed
    }

  };

  return (
    <div className="d-flex align-items-center">
      {[1, 2, 3, 4, 5].map((star) => (
        <Button
          key={star}
          variant="link"
          className="p-0 me-1"
          onClick={() => handleClick(star)}
          onMouseEnter={() => setHovered(star)}
          onMouseLeave={() => setHovered(null)}
          rating={rating}
        >
          <FaStar
            size={24}
            color={star <= (hovered || rating) ? "#ffc107" : "#e4e5e9"}
          />
        </Button>
      ))}
      <span className="ms-2">{rating}</span>
    </div>
  );
};

export default RatingStar;
